import Dbm from "dbm";
import Website from "../../index.js";

export default class HoleFade extends Dbm.core.BaseObject {
    _construct() {
        super._construct();

        let container = new PIXI.Container();
        this.item.setValue("pixiLayer", container);
        
        const graphics = new PIXI.Graphics();
        container.addChild(graphics);
        this.item.setValue("graphics", graphics);

        this.item.setValue("x", 0);
        this.item.setValue("y", 0);
        this.item.setValue("envelope", 0);
    }

    update(aTime, aDelta) {
        //console.log("update");

        let graphics = this.item.graphics;
        
        graphics.clear();

        

        let envelope = this.item.envelope;
        if(envelope) {
            let size = Math.sqrt(Math.pow(Website.game.Sizes.WIDTH, 2), Math.pow(Website.game.Sizes.HEIGHT, 2));
            let rect = graphics.rect(-1*size, -1*size, Website.game.Sizes.WIDTH+2*size, Website.game.Sizes.HEIGHT+2*size).fill(0x000000);

            let x = Math.max(0, Math.min(Website.game.Sizes.WIDTH, this.item.x));
            let y = Math.max(0, Math.min(Website.game.Sizes.HEIGHT, this.item.y));

            rect.circle(x, y, (1-envelope)*size).cut();

        }

        


    }
}